<template>
	<div class="main-container">
		<div class="back_left" @click="$router.go(-1)" />
		<!-- 标题 -->
		<div class="headers">
			<h1>名额申请</h1>
		</div>
		<!-- 图片/会议 -->
		<div class="meeting-img">
			<img class="max_img" src="../images/user/fuping.jpg" alt="国家开发银行扶贫名额发布会" />
		</div>
		<!-- 说明文字 -->
		<div class="desc" style="position: relative;margin-bottom: 50px;height: 130px;">
			获得国家开发银行扶贫名额即可追回亏损资金以及享受快速提现扶贫款资金到账，直接提现到本人银行卡，同时可以解冻因参与其他项目被冻结的银行卡。
			<!-- 立即申请按钮 -->
			<div class="apply-btn">
				<!-- <button v-if="benefitStatus == 0">审核中!</button> -->
				<button v-if="datawudi.paymentswitch === 0 && datawudi.inviteCount >= 5" disabled>
					已申请！审核中！
				</button>
				<button v-else-if="datawudi.paymentswitch === 0 && datawudi.inviteCount < 5" @click="inviteQuota">
					点击获取名额
				</button>
				<button v-else-if="datawudi.paymentswitch == 1 && datawudi.payment == 0" @click="applyQuota">
					点击获取名额
				</button>
				<button v-else-if="datawudi.paymentswitch == 1 && datawudi.payment == 1" @click="getUser">已获得名额</button>
			</div>
		</div>

		<!-- 详细说明 -->
		<div class="detail">
			此次所有扶贫款项由国家开发银行扶贫事业部统一发放，申请名额限量50000个，中国公民都可以申请参与扶贫助困名额！早获得早脱贫！⚠️所有款项只可用于改善生活！不得用于投资理财，禁止使用扶贫款项参与民族资产解冻类项目，一经发现立即取消扶贫资格并冻结款项。
		</div>
		<!-- 时政要闻 -->
		<div class="news">
			<h3>时政要闻</h3>
			<ul>
				<li v-for="item in newsList" :key="item.id" @click="openLink(item.link)">
					<div class="news_left">
						<a :href="item.link" target="_blank" style="color: black;">
							<span>{{ item.title }}</span>

						</a>
						<span class="time">{{ item.time }}<span class="toptext">热搜</span></span>
					</div>
					<div class="news_right">
						<img class="news_img" src="../images/user/fuping.jpg" alt="国家开发银行扶贫名额发布会" />
					</div>

				</li>
			</ul>
		</div>
		<!-- 底部备案信息 -->
		<div class="footers">
			<span>京ICP备05070218号 |<img style="width: 20px;height: 20px;line-height: 20px;"
					src="../images/user/cpolic2.png" alt="">京公网安备11010202000001号</span>

		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	export default {
		name: "QuotaApplyPage",
		data() {
			return {
				datawudi: {
					paymentswitch: null,
					payment: null
				},
				benefitStatus: '',
				newsList: [{
						id: 1,
						title: "国家开发银行拟设立扶贫金融部",
						time: "2025年5月19日10:05:00",
						link: "https://www.gov.cn/xinwen/2016-04/25/content_5067706.htm"
					},
					{
						id: 2,
						title: "国家开发银行金融事业部筹备成立",
						time: "2025年5月19日10:05:00",
						link: "http://money.people.com.cn/bank/GB/n1/2016/0601/c202331-28400294.html"
					},
					{
						id: 3,
						title: "国家开发银行首届“金融四甲”",
						time: "2025年5月19日10:05:00",
						link: "https://mbd.baidu.com/ma/s/1BbSouvK"
					}
				]
			}
		},
		created() {
			this.$parent.footer('losePage');
			// 看个人信息
			this.starts();
		},
		methods: {
			openLink(link) {
				window.open(link, '_blank');
			},
			getUser() {
				this.$router.push('/user');
			},
			applyQuota() {
				this.$router.push({
					path: '/payment',
					query: {
						type: 0
					}
				})
			},
			inviteQuota() {
				if (this.datawudi.inviteCount == 0) {
					this.$toast({
						className: "toastName",
						message: `还需要邀请5位好友`,
					});
					return;
				} else if (this.datawudi.inviteCount == 1) {
					this.$toast({
						className: "toastName",
						message: '还需要邀请4位好友',
					});
					return;
				} else if (this.datawudi.inviteCount == 2) {
					this.$toast({
						className: "toastName",
						message: '还需要邀请3位好友',
					});
					return;
				} else if (this.datawudi.inviteCount == 3) {
					this.$toast({
						className: "toastName",
						message: '还需要邀请2位好友',
					});
					return;
				} else if (this.datawudi.inviteCount == 4) {
					this.$toast({
						className: "toastName",
						message: '还需要邀请1位好友',
					});
					return;
				}
			},
			async starts() {
				const r = await Fetch('/user/info');
				this.datawudi = r.data;
				// console.log(this.datawudi.payment)
			},
		}
	}
</script>

<style scoped>
	.main-container {
		background: url(../images/user/loginmax2.png) no-repeat center;
		background-size: 112% 102%;
		height: 100%;
		max-width: 500px;
		margin: 0 auto;
		/* border-radius: 16px; */
		overflow: hidden;
		font-family: '微软雅黑', Arial, sans-serif;
		/* box-shadow: 0 0 8px #eee; */
	}

	.headers {
		text-align: center;
		margin: 0 0 12px 0;
		color: #d90000;
		font-size: 24px;
		font-weight: bold;
	}

	.meeting-img {
		margin: 16px;
		display: flex;
		justify-content: center;

	}

	.max_img {
		width: 300px;
		height: 157px;

	}

	.desc {
		letter-spacing: 3px;
		text-indent: 2em;
		line-height: 1.5;
		background: #ffeaea;
		margin: 16px;
		padding: 12px;
		border-radius: 8px;
		color: #333;
		font-size: 13px;
	}

	.detail {
		letter-spacing: 3px;
		text-indent: 2em;
		line-height: 1.5;
		margin: 16px;
		padding: 12px;
		border-radius: 8px;
		color: #333;
		font-size: 13px;
	}

	.apply-btn {
		text-align: center;
		/* margin: 16px 0; */
		position: absolute;
		bottom: -19%;
		left: 45%;
		transform: translateX(-50%);
	}

	.apply-btn button {
		background: #ff4d4f;
		color: #fff;
		border: none;
		border-radius: 22px;
		padding: 12px 20px;
		font-size: 16px;
		cursor: pointer;
		box-shadow: 0 2px 8px #ffcccc;
	}

	.news {
		margin: 20px 16px;
	}

	.news h3 {
		font-size: 17px;
		color: #d90000;
		margin-bottom: 8px;
	}

	.news ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.news li {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		padding: 4px 0;
		border-bottom: 1px solid #f1f1f1;
	}

	.news .time {
		color: #999;
		font-size: 13px;
	}

	.news_right {
		width: 100px;
		height: 50px;


	}

	.news_img {
		width: 100px !important;
		height: 50px !important;
		border-radius: 6px;
	}

	.news_left {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.toptext {
		display: inline-block;
		color: #fff;
		margin-left: 5px;
		background: #d90000;
		border-radius: 5px;
		font-size: 12px;
		padding: 5px;
	}

	.footers {
		max-width: 500px;
		/* position: absolute; */

		/* bottom: 10px; */
		width: 100%;
		text-align: center;
		color: #fff;
		font-size: 13px;
		background: #ff4d4f;
		padding: 12px 0 8px 0;
		/* margin-top: 24px; */
	}
</style>